import React, { FC } from "react";

import { faEllipsis } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AntDAvatar from "antd/es/avatar";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";

import { UserRef } from "@mapmycustomers/shared/types/User";
import { userDisplayName } from "@mapmycustomers/shared/util/formatters";
import { Avatar } from "@mapmycustomers/ui";

import styles from "./AvatarGroup.module.scss";

const DEFAULT_USER_LIMIT = 4;

export interface AvatarGroupProps {
  className?: string;
  limit?: number;
  size?: "medium" | "small";
  users: UserRef[];
}

const AvatarGroup: FC<AvatarGroupProps> = ({
  className,
  limit = DEFAULT_USER_LIMIT,
  size = "medium",
  users,
}) => {
  if (!users.length) {
    return null;
  }

  return (
    <Tooltip
      title={
        <div>
          {users.map((user) => (
            <div key={user.id}>{userDisplayName(user)}</div>
          ))}
        </div>
      }
    >
      <div className={cn(styles.container, styles[size], className)}>
        {users.slice(0, limit).map((user) => (
          <Avatar className={styles.avatar} key={user.id} tooltip={false} user={user} />
        ))}
        {users.length > limit && (
          <AntDAvatar className={cn(styles.avatar, styles.moreUsers)}>
            <FontAwesomeIcon icon={faEllipsis} />
          </AntDAvatar>
        )}
      </div>
    </Tooltip>
  );
};

export default AvatarGroup;
